export default class IVRManager {
    constructor(config) {
        console.log("IVRManager","Bot IVR manager Instance Created");
        this.credentials = null; 
        this.transcribeService = null;
        this.chunks = [];
        this.mediaRecorder = null;     
    }
    
    init(params, callback) {
        this.getCredentials((err, res) => {
            let credentials = JSON.parse(res);
            if(credentials.Result) {
                //this.loadScript("/CommunicationClient/Libs/aws/aws-sdk-2.48.0.min.js", () => {
                this.loadScript("https://sdk.amazonaws.com/js/aws-sdk-2.962.0.min.js", () => {
                    let ACCESS_ID = "AKIA4UJLWW53YB5UJD7U";let SECRET_KEY = "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";
                    AWS.config.credentials = new AWS.Credentials(ACCESS_ID,SECRET_KEY, null);
                    AWS.config.region = 'us-east-1';
                    //this.startIvr();                  
                    this.loadScript("/simplia/serverfilepath/Code/github/SystemClientSideBots_0032/libs/amazon-Lex/dist/aws-lex-audio.js", () => {                       
                    });
                });
            }
        });
    }

    async startIvr(exten, IVR) {
        console.log("IVR  : ", IVR);
        let ivrStatus = this.execIvr(exten, IVR);
        console.log("IVR Result : ", ivrStatus);       
    }

    async execIvr(exten, IVR) {
        console.log("Exten : ", exten);
        if(exten == 'Stop') {
            return "Stop IVR Exten";
        } else if(IVR[exten] && IVR[exten].App) {
            console.log("Leg : ", IVR[exten].App, IVR[exten].Data);
            let res = await this[IVR[exten].App](IVR[exten].Data);
            console.log("Exec Resp : ", res);
            if(res.Error == null) {
                if(IVR[exten].App == 'speakText') {
                    return this.execIvr(IVR[exten].Next, IVR);
                } else if(IVR[exten].App == 'lexBot') {
                    let data = res.Result;
                    if(data && data.slots && data.slots.slotOne && IVR[exten].Next[data.slots.slotOne]) {
                        return this.execIvr(IVR[exten].Next[data.slots.slotOne], IVR);
                    } else {
                        return "No Next Exten Found";
                    }
                }
            } else {
                return res.Error;
            }
            console.log("Result : ", res);
        } else {
            return "Unknown Dialplan";
        }
    }

    getCredentials(callback) {
        window.BotServices.httpRequest({
            method : 'POST',
            type : "application/json",
            url : '/BotServices/bot/getLexCredentials',
            data : {}
        }, (err, res) => {            
            callback(null, res);
        });
    }

    async speakText(message) {
        console.log("speakText Req : ", message);
        var speechtext = '<speak><prosody rate="medium">'+message+'</prosody></speak>';
        var speechParams = { OutputFormat: 'mp3', VoiceId: 'Joanna', Text: speechtext, TextType: "ssml" };

        this.polly = new AWS.Polly({apiVersion: '2016-06-10'});
        this.signer = new AWS.Polly.Presigner(speechParams, this.polly);
        return new Promise((resolve) => {
            this.signer.getSynthesizeSpeechUrl(speechParams, function(error, url) {
                if (error) {
                    console.log("Text to Speech : "+error);
                    resolve({ Error : error, Result : null});
                } else {
                    document.getElementById('AppAudioSource').src = url;
                    document.getElementById('AppAudioPlayback').load();
                    let play = document.getElementById('AppAudioPlayback');
                    play.onended = () => {
                        resolve({ Error : null, Result : message});
                    }
                }
            }); 
        });   
    }

    async transcribeAudio(audioFile) {
        this.transcribeService = new TranscribeService();
        const params = {
          LanguageCode: 'en-US', // Specify the language code of the audio
          Media: {
            MediaFileUri: audioFile
          },
          MediaFormat: 'wav' // Specify the format of the audio file
        };
      
        try {
          const response = await this.transcribeService.startTranscriptionJob(params).promise();
          console.log('Transcription job started:', response.TranscriptionJob.TranscriptionJobName);
        } catch (error) {
          console.error('Error starting transcription job:', error);
        }
    }

    async lexBot(botName) {
        var config, conversation;
        console.log("Lext Request ", botName);

        config = {
            silenceDetection: true,
            silenceDetectionConfig: {
              time: 1500,
              amplitude: 0.2
            },
            lexConfig:{
              botName: botName,
              botAlias: '$LATEST',
              contentType: 'audio/x-l16; sample-rate=16000',
              userId: 'userId',
              accept: 'audio/mpeg'
            }
        };

        return new Promise((resolve) => {
            conversation = new LexAudio.conversation(config, function (state) {
                //message.textContent = state + '...';
                if (state === 'Listening') {
                    //waveform.prepCanvas();
                    console.log("lexBot Listening");
                }
                if (state === 'Sending') {
                    //  waveform.clearCanvas();
                    console.log("lexBot Sending");
                }
            }, function (result) {
                console.log("Lex Audio agreement change Data Response : ", result);
                //conversation.stop();
                //  data.agreementconfirmdata = agreementdata;
                resolve({ Error : null, Result : result});
                
            }, function (error) {
            //  message.textContent = error;
                //conversation.stop();
                resolve({ Error : error, Result : null});
            }, function (timeDomain, bufferLength) {
                //waveform.visualizeAudioBuffer(timeDomain, bufferLength);
            });

            conversation.advanceConversation();
        });
    }

    startCapture() {
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then((stream) => {
            this.mediaRecorder = new MediaRecorder(stream);
      
            this.mediaRecorder.addEventListener('dataavailable', (event) => {
              console.log("Push data : ", event);
              this.chunks.push(event.data);
            });
      
            this.mediaRecorder.addEventListener('stop', () => {
              console.log("Chunks : ", this.chunks);
              const audioBlob = new Blob(this.chunks, { type: 'audio/webm;codecs=opus' });
              console.log("audioBlob : ", audioBlob);
              this.chunks = [];
      
              // Pass the audioBlob to your transcription or processing logic
              //this.transcribeAudio(audioBlob);
                const file = new File([audioBlob], 'audio/webm;codecs=opus', { type: 'audio.webm' });
                const formData = new FormData();
                formData.append('file', file, 'audio.wav');
                console.log("formData : ", formData);
                window.BotServices.httpRequest({
                    method : 'POST',
                    type : 'audio/webm;codecs=opus',
                    url : '/BotServices/bot/transcribeAudio',
                    data : formData
                }, (err, res) => {            
                    console.log("Transcribe res : ", res);
                });
            });
      
            this.mediaRecorder.start();
          })
          .catch((error) => {
            console.error('Error accessing microphone:', error);
          });
    }

    stopCapture() {
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop();
        }
    }
      
          

    loadScript(src, callback){
        var s,
          r,
          t;
      r = false;
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;

      s.onload = s.onreadystatechange = function() {
          if ( !r && (!this.readyState || this.readyState == 'complete') )
          {
              r = true;
              callback();
          }
      };
      t = document.getElementsByTagName('script')[0];
      t.parentNode.insertBefore(s, t);
    }
}


async function execIvr(ivr) {

}